import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "pl-3" }
const _hoisted_2 = { class: "pr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_UploadRow = _resolveComponent("UploadRow")!
  const _component_VEmpty = _resolveComponent("VEmpty")!
  const _component_UploadPanel = _resolveComponent("UploadPanel")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('upload.table.dateiname')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('upload.table.groesse')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('upload.table.typ')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('upload.table.schlagworte')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadFiles, (row, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_UploadRow, {
                    "upload-file": row,
                    typen: _ctx.dokumentTypen,
                    onRemove: _ctx.removeFile
                  }, null, 8, ["upload-file", "typen", "onRemove"])
                ]))
              }), 128)),
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "pa-5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UploadPanel, {
                            id: "uploadZone",
                            "show-filelist": false,
                            multiple: true,
                            "instant-upload": true,
                            class: "pl-3",
                            "onUpdate:modelValue": _ctx.saveFileInArrayDropzone
                          }, {
                            button: _withCtx(() => [
                              _createVNode(_component_VEmpty)
                            ]),
                            _: 1
                          }, 8, ["onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "1" }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.setDokumentTyp,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setDokumentTyp) = $event)),
                            class: "mt-5",
                            items: _ctx.dokumentTypen,
                            dense: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            ref: "combobox",
                            modelValue: _ctx.selectedSchlagworte,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSchlagworte) = $event)),
                            search: _ctx.schlagwortSearchString,
                            "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schlagwortSearchString) = $event)),
                            items: _ctx.schlagwortSelection,
                            label: _ctx.$t('upload.table.schlagworte'),
                            "hide-no-data": !_ctx.schlagwortSearchString,
                            "bg-color": "white",
                            class: "mt-3",
                            "append-icon": "",
                            multiple: "",
                            "clear-on-select": true,
                            "hide-selected": true,
                            "custom-filter": _ctx.customFilter,
                            onKeydown: _withKeys(_withModifiers(_ctx.simulateEnter, ["prevent"]), ["space"])
                          }, {
                            selection: _withCtx(({ attrs, item, selected, index }) => [
                              _createVNode(_component_v_chip, _mergeProps(attrs, {
                                "input-value": selected,
                                label: "",
                                small: "",
                                closable: "",
                                "onClick:close": ($event: any) => (_ctx.deleteSchlagwortFromSelection(index, item.raw))
                              }), {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.value), 1)
                                ]),
                                _: 2
                              }, 1040, ["input-value", "onClick:close"])
                            ]),
                            item: _withCtx(({ props, item, index }) => [
                              (item.raw.header && _ctx.search)
                                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mr-3" }, "Create", -1)),
                                      _createVNode(_component_v_chip, {
                                        size: "small",
                                        variant: "flat",
                                        label: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.search), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : (item.raw.header)
                                  ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                      key: 1,
                                      title: item.title
                                    }, null, 8, ["title"]))
                                  : (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      onClick: props.onClick
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          icon: "mdi-delete",
                                          size: "small",
                                          variant: "text",
                                          onClick: _withModifiers(($event: any) => (_ctx.deleteSchlagwortFromDatabase(index, item.raw)), ["stop","prevent"])
                                        }, null, 8, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_chip, {
                                          text: item.raw,
                                          variant: "outlined"
                                        }, null, 8, ["text"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "search", "items", "label", "hide-no-data", "custom-filter", "onKeydown"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                id: "fileUpload",
                type: "file",
                multiple: "",
                hidden: "",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveFileInArrayButton && _ctx.saveFileInArrayButton(...args)))
              }, null, 32),
              _createVNode(_component_v_row, { class: "mt-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { sm: "2 pt-0 pb-5" }, {
                    default: _withCtx(() => [
                      (_ctx.uploadFiles.length < 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            large: "",
                            color: "primary",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.chooseFiles()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('upload.button.auswaehlen')), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            large: "",
                            color: "primary",
                            onClick: _ctx.uploadDokumenteWrapper
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('upload.button.confirm')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { sm: "8 pt-0 pb-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", null, _toDisplayString(_ctx.$t('upload.remarks')), 1),
                      _cache[6] || (_cache[6] = _createTextVNode()),
                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("i", null, _toDisplayString(_ctx.allowedFileTypes.join(', ')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}